import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { makeQueryString } from "core/makeQueryString";
import { AxiosContext } from "contexts/AxiosContext";
import { AlertsResponse } from "interfaces/alert";
import { EntitlementContext } from "contexts/UserProfileContext";
import { FeaturesContext } from "contexts/FeaturesContext";

export const useAlertsQuery = (
  page = 1,
  pageSize = 10000
): UseQueryResult<AlertsResponse> => {
  const { axios } = useContext(AxiosContext)!;
  const { hasFeature } = useContext(FeaturesContext);
  const { hasEntitlement } = useContext(EntitlementContext);

  const queryString = makeQueryString({ page, size: pageSize });

  // Feature and permission checks
  const hasAlertFeature = hasFeature("alerts") ?? false;
  const hasAlertPermission = hasEntitlement("alerts-view") ?? false;

  const queryResult = useQuery({
    queryKey: ["alerts", queryString],
    queryFn: async () => {
      const { data } = await axios.get<AlertsResponse>(`/alerts${queryString}`);
      return data;
    },
    enabled: hasAlertFeature && hasAlertPermission
  });

  return queryResult;
};
